import React from "react"

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"

const Stats = (props) => {
  const newVisitors = [
    {
      name: "Jan",
      2019: 539,
      2020: 2206,
      2021: 5032,
    },
    {
      name: "Feb",
      2019: 929,
      2020: 1618,
      2021: 3825,
    },
    {
      name: "Mars",
      2018: 42,
      2019: 1077,
      2020: 4249,
      2021: 3711,
    },
    {
      name: "April",
      2018: 98,
      2019: 758,
      2020: 4461,
      2021: 3326,
    },
    {
      name: "Mai",
      2018: 96,
      2019: 832,
      2020: 3186,
      2021: 2184,
    },
    {
      name: "Juni",
      2018: 76,
      2019: 984,
      2020: 1457,
    },
    {
      name: "Juli",
      2018: 13,
      2019: 61,
      2020: 111,
    },
    {
      name: "Aug",
      2018: 106,
      2019: 1017,
      2020: 1297,
    },
    {
      name: "Sept",
      2018: 64,
      2019: 1592,
      2020: 1575,
    },
    {
      name: "Okt",
      2018: 138,
      2019: 1108,
      2020: 1694,
    },
    {
      name: "Nov",
      2018: 177,
      2019: 1301,
      2020: 2453,
    },
    {
      name: "Des",
      2018: 335,
      2019: 789,
      2020: 1863,
    },
  ]

  return (
    <>
      <ResponsiveContainer id="lineChart" width="40%" height={300}>
        <LineChart
          width={900}
          height={300}
          data={newVisitors}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="1 1" />
          <XAxis
            dataKey="name"
            tick={{ fontSize: "16px", width: "50px", wordWrap: "break-word" }}
            minTickGap={1}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="2021"
            stroke="#64a731"
            activeDot={{ r: 8 }}
            strokeWidth={3}
          />
          <Line
            type="monotone"
            dataKey="2020"
            stroke="#DB78E3"
            activeDot={{ r: 8 }}
            strokeWidth={3}
          />
          
          <Line
            type="monotone"
            dataKey="2019"
            stroke="#E378B6"
            activeDot={{ r: 8 }}
            strokeWidth={3}
          />
                    <Line
            type="monotone"
            dataKey="2018"
            stroke="#78B6E3"
            activeDot={{ r: 8 }}
            strokeWidth={3}
          />
        </LineChart>
      </ResponsiveContainer>

      {/* <ResponsiveContainer width="30%">
        <BarChart width={730} height={250} data={newVisitors}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="2018" fill="#78B6E3" />
          <Bar dataKey="2019" fill="#E378B6" />
          <Bar dataKey="2020" fill="#DB78E3" />
        </BarChart>
      </ResponsiveContainer> */}
    </>
  )
}

export default Stats
